module.exports = __webpack_public_path__ + "static/media/tab-4-image.bba5788f.png";